import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { filter, orderBy, reduce, take, toNumber } from "lodash";

export const getTopBehaviouralStrengthsDimensions = (
  dimensions: DimensionWithScores[],
  topCount = 3
) => {
  const mainDimensions = filter(dimensions, (d) => !d.parentId);

  const elligibleDimensions = reduce(
    mainDimensions,
    (result: DimensionWithScores[], mainDimension: DimensionWithScores) => {
      const subDimensions = filter(
        dimensions,
        (d) => d.parentId === mainDimension.id
      );

      const elligibleSubDimensions = filter(subDimensions, (sd) => {
        if (!mainDimension.score.value) return false;
        if (mainDimension.score?.value > 50)
          return toNumber(sd.textsScore?.value) > 50;
        if (mainDimension.score?.value < 50)
          return toNumber(sd.textsScore?.value) < 50;
        return true;
      });
      return [...result, ...elligibleSubDimensions];
    },
    []
  );

  const strengthDims = take(
    orderBy(
      elligibleDimensions,
      (d) => Math.abs(50 - (d.textsScore?.value || 0)),
      "desc"
    ),
    topCount
  );

  return strengthDims;
};
